export default {
  mapRightClick: {
    options: 'Aktionen',
    addDestinationToRoute: 'Als Ziel hinzufügen',
    directionsFromHere: 'Route von hier',
    directionsToHere: 'Route hierher',
    nonStopDirectionsToHere: 'Route verwerfen und hierher',
    addRouteStop: 'Als Wegpunkt hinzufügen',
    centerHere: 'Als Kartenmittelpunkt verwenden',
    addAsIsochroneCenter: 'Als Zentrum verwenden',
    inspectDataOnOSM: 'Daten in OSM anzeigen'
  }
}
